import React from "react";
import PropTypes from "prop-types";
import {FaSolidIcon} from "../../../../components/FontAwesomeIcons";
import SafeHtmlContainer from "../../../../helpers/SafeHtmlContainer";
import {markdownToHTML} from "../../../../helpers/Markdown";
import {CHAT_SENDER_COLORS, getSenderClassNameForUserId, getSenderColorIndexForUserId} from "./Utils";


export function ReplyMessagePreview(props) {

    const {type, metadata} = props.message;

    let text = '';
    if (type == 'media') {
        const [mimeGenericType, mimeSpecificType] = metadata.mime_type.split('/');
        switch (mimeGenericType) {
            case 'image':
                text = <div className={"small"}><FaSolidIcon name={"camera"}/> Immagine</div>;
                break;
            case 'audio':
                text = <div className={"small"}><FaSolidIcon name={"microphone"}/> Messaggio vocale</div>;
                break;
            case 'video':
                text = <div className={"small"}><FaSolidIcon name={"video-camera"}/> Video</div>;
                break;
            default:
                text = <div className={"small"}><FaSolidIcon name={"file-alt"}/> File</div>;
                break;

        }
    } else {
        switch (type) {
            case 'text':
            case 'auto':
                text = <div className={"small"}>
                    <SafeHtmlContainer html={markdownToHTML(props.message.contenuto.substring(0, 100), true)}/>
                </div>;
                break;
            default:
                text = <span/>;
                break;
        }
    }

    const isMine = parseInt(props.message.id_mittente) === parseInt(props.idSelf);
    let senderText = <b>Messaggio automatico</b>;
    const senderId = props.message?.metadata?.helpdesk_superadmin?.id_admin || props.message?.metadata?.helpdesk_admin?.id_admin || 0;
    if (props.message?.metadata?.helpdesk_superadmin) {
        senderText = <b className={getSenderClassNameForUserId(senderId)}>
            {isMine ? "Tu" : props.message.metadata.helpdesk_superadmin.nome}
        </b>
    } else if (props.message?.metadata?.helpdesk_admin) {
        senderText = <b className={getSenderClassNameForUserId(senderId)}>
            {isMine ? "Tu" : props.message.metadata.helpdesk_admin.nome}
        </b>
    }

    const style = {
        backgroundColor: 'rgba(80,80,80,0.05)',
        borderLeft: `3px solid ${CHAT_SENDER_COLORS[getSenderColorIndexForUserId(senderId)]}`
    }

    return (
        <React.Fragment>
            <div className={"replay-to-preview rounded p-1 cursor-pointer d-flex flex-nowrap justify-content-between"}
                 style={style} onClick={props.onClick}>
                <div>
                    <div>{senderText}</div>
                    {text}
                </div>
                {
                    !!props.onCancel &&
                    <button type="button" className="btn btn-sm btn-link text-muted" onClick={props.onCancel}>
                        <FaSolidIcon name={"times"}/>
                    </button>
                }
            </div>
        </React.Fragment>
    )
}

ReplyMessagePreview.propTypes = {
    message: PropTypes.object.isRequired,
    onCancel: PropTypes.func,
    idSelf: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}
